import { Utils } from "src/modules/utils/shared/utils";
import { EnaioObjectId } from "./EnaioObjectId";
import { EnaioObjectTypeId } from "./EnaioObjectTypeId";
import { Type } from "class-transformer";
import { EnaioCabinet } from "./EnaioCabinet";
import { EnaioGuiBounds } from "./EnaioGuiBounds";
import { EnaioGuiField } from "./EnaioGuiField";
import { EnaioMainType } from "./EnaioMainType";
import { EnaioObjectDefTranslation } from "./EnaioObjectDefTranslation";
import { EnaioObjectLimit } from "./EnaioObjectLimit";

export class EnaioObjectType {
    @Type(() => EnaioCabinet)
    parent: EnaioCabinet;
    mainType: EnaioMainType = EnaioMainType.folder;
    coType = 0;
    name = "";
    internalName = "";
    osGuid = "";
    tableName = "";
    exTableName = "";
    iconId = 0;
    historyFlags = 0;
    compressionFlags = 0;
    referenceType = 0;
    noDias = false;
    onlyIndexData = false;
    fullText = 0;
    multiDoc = false;
    applySecurity = false;
    @Type(() => EnaioGuiBounds)
    bounds: EnaioGuiBounds;
    @Type(() => EnaioGuiField)
    fields: EnaioGuiField[];
    @Type(() => EnaioObjectLimit)
    objectLimits: EnaioObjectLimit[];
    @Type(() => EnaioObjectDefTranslation)
    translatedNames: EnaioObjectDefTranslation[];
    Id = 0;


    getAllFields(): EnaioGuiField[] {
        return Utils.arrayExplode(this.fields, f => [f, ...Utils.arrayExplode(f.pages, p => p.fields)]);
    }

    getObjectId(): EnaioObjectId {
        return new EnaioObjectId(this.name, this.internalName);
    }

    getObjectTypeId(): EnaioObjectTypeId {
        return new EnaioObjectTypeId(this.parent.getObjectId(), this.getObjectId());
    }


}
